import * as types from '../mutation-types'
import api from '@/api/agenda'
import fileApi from '@/api/files'
import router from "@/router";

// initial state
const state = {
    agendaEvent: {},
    loaded: false,
    content_loaded: 0,
    agendaAdditionalInformation: {}
}

const getters = {
    agendaEvent: state => state.agendaEvent,
    agendaAdditionalInformation: state => state.agendaAdditionalInformation,
    agendaEventLoaded: state => state.loaded,
    agendaAdditionalInformationLoaded: state => state.content_loaded,
}

const actions = {
    getAgendaEvent({ commit }, payload) {
        commit(types.SET_AGENDA_EVENT_LOADED, false );
        api.getAgenda(payload,(response) => {
            if(!response._embedded.Agenda[0]) {
                router.push('/404')
            }
            commit(types.SET_AGENDA_EVENT, response._embedded.Agenda[0] );
            commit(types.SET_AGENDA_EVENT_LOADED, true );
        })
    },
    setAgendaAdditionalInformation({commit, getters, dispatch}, payload) {
        console.log(`additional agenda type ${payload.type}`)
        commit(types.SET_AGENDA_ADDITIONAL_DATA_LOADED, false );
        switch (payload.type) {
            case 0:
                if(getters.settingsCompanyByParentId(payload.idSettingCompany).length) {
                    dispatch('getTeamMembers')
                }
                //HTMLCONTENT
                return;
            case 1:
                //TABLE
                return;
            case 2:
                //COLLATERALS
                return;
            case 3:
                //MAP
                return;
            case 4:
                //SUBTABS
                return;
            case 5:
                //FILES
                fileApi.getCompanyFiles( {idSettingCompany: payload.idSettingCompany},(response) => {
                    commit(types.SET_AGENDA_ADDITIONAL_DATA, {id: payload.idSettingCompany, data: response._embedded.FileCompany} );
                    commit(types.SET_AGENDA_ADDITIONAL_DATA_LOADED, true );
                })
                return;
            case 6:
                //SOLUTIONS
                return;
        }

    },
    cleanAgendaEvent({commit}) {
        commit(types.SET_AGENDA_EVENT_LOADED, false );
        commit(types.SET_AGENDA_EVENT, {} );
    }
}

const mutations = {
    [types.SET_AGENDA_EVENT] (state, solution ) {
        state.agendaEvent = solution
    },
    [types.SET_AGENDA_ADDITIONAL_DATA] (state, data ) {
        state.agendaAdditionalInformation[data.id] = data.data
    },
    [types.SET_AGENDA_EVENT_LOADED] (state, status ) {
        state.loaded = status
    },
    [types.SET_AGENDA_ADDITIONAL_DATA_LOADED] (state, status ) {
        state.content_loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


